// extracted by mini-css-extract-plugin
module.exports = {"dropdownActionButton":"dropdownActionButton_dropdownActionButton__2GIXm","ellipsisIcon":"dropdownActionButton_ellipsisIcon__LYGT3"};